module.exports = __webpack_public_path__ + "img/header-buchdruckerei-styria.c162951a.jpg";